import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getUrl } from '../_shared/utils';
import { Observable } from 'rxjs';
import { Venue } from '../_models/Venue';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class VenueService {
  private serviceUrl: string;

  constructor(
    private http: HttpClient,
    private jwtTokenService: JWTTokenService) {
      this.serviceUrl = getUrl('venue');
    }

    public create(venue: Venue) {
      return this.http.post<any>(`${this.serviceUrl}/create` , venue, this.requestOptionsAuthenticated());
    }

    public update(venue: Venue) {
      return this.http.post<any>(`${this.serviceUrl}/update` , venue, this.requestOptionsAuthenticated());
    }

    public delete(venueId: number) {
      return this.http.get(`${this.serviceUrl}/delete/${venueId}`, this.requestOptionsAuthenticated());
    }

    public get(): Observable<Venue[]> {
      return this.http.get<Venue[]>(`${this.serviceUrl}`, this.requestOptionsAuthenticated());
    }

    public getById(venueId: number): Observable<Venue> {
      return this.http.get<Venue>(`${this.serviceUrl}/${venueId}`, this.requestOptionsAuthenticated());
    }

    private requestOptionsAuthenticated() {
      const requestOptions = {
          headers: new HttpHeaders()
              .set('Content-type', 'application/json')
              .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken('portal')),
      };
      return requestOptions;
    }
}


